import React from "react";
import speedometer from "../../assets/img/speedometer.svg";
import gasolinePump from "../../assets/img/gasoline-pump.svg";
import appstore from "../../assets/img/appstore.png";
import googleplay from "../../assets/img/googleplay.png";
import cars01 from "../../assets/img/cars01.png";
import { useHistory, useParams } from "react-router-dom";
import API from "../../Services/BaseService";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../Component/Loading/Loading";
import UrCarAction from "../UrCar/UrCarAction";
import DealerAction from "../DealerRedux/DealerAction";
import odometer from '../../assets/img/miles.jpg';
import ls from "local-storage";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import wsBaseURL from '../../Services/Constant';
// import { w3cwebsocket as W3CWebSocket } from "websocket";

// const ws=new WebSocket(wsBaseURL);
// const contentDefaultMessage = "Start writing your document here";

import PageNotFound from "../FallBackUI/PageNotFound";

const InActiveCars = () => {


  const CustomPrevArrow = (props) => (
    <button {...props} className="custom-prev-arrow">
      &lt; {/* Left arrow */}
    </button>
  );

  const CustomNextArrow = (props) => (
    <button {...props} className="custom-next-arrow">
      &gt; {/* Right arrow */}
    </button>
  );



  const responsiveSettings = [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
      },
    },
    {
      breakpoint: 420,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
      },
    },
  ];


  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const dealerData = useSelector((state) => state.DealerReducer.payload);
  console.log(dealerData, "dealerData=====");
  const dispatch = useDispatch();
  const [carDetail, setCarDetail] = useState([]);
  const successData = useSelector((state) => state.LoginReducer.payload);
  const [VINNumber, setVINNumber] = useState("");
  const [year, setYear] = useState("");
  const [make, setMake] = useState("");
  const [model, setModel] = useState("");
  const [vinError, setVinError] = useState("");
  const [dealerList, setDealerList] = useState("");
  const [dealerId, setDealerId] = useState("");
  const [selectedSellerDetails, setSelectedSellerDetails] = useState("");
  const [errors, setErrors] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);
  const [dealername, setDealerName] = useState("");
  const [flagFilter, setFalgFilter] = useState(false);
  const Status = ls.get("carStatus");

  const [value, setValue] = useState(Status === undefined || Status === "undefined" || Status === "" || Status === null || Status === "null" ? "Inactive" : Status);

  console.log(Status, "test");
  const sellerStandingStatus = ls.get("sellerStandingStatus");

  // const wsCall = () => {

  //     ws.onopen = () => {
  //         console.log('WebSocket ws Connected');
  //     };

  //     console.log('wsCall===========>', );
  //     ws.send(JSON.stringify({seller_dealer_id:successData.seller_dealer_id ,model:'inActiveCars'}))

  //     ws.onmessage = (message) => {
  //         console.log("check the message in count details  ===",message)
  //         const dataFromServer = JSON.parse(message.data)
  //         console.log("check the  data FromServer", dataFromServer)

  //         switch(dataFromServer[1]) {

  //             case "inActiveCars":

  //               getinactivecar (dataFromServer[0]);

  //                 break;

  //             default:

  //         }

  //     }

  // }

  const numberPattern = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setYear(value);
  };

  const handleSellerDetailsName = (e) => {
    setDealerId(e.target.value);
    setSelectedSellerDetails(
      dealerList.filter((data) => data.seller_dealer_id == e.target.value)[0]
    );
    const selectedSellerDetails = dealerList.filter(
      (data) => data.seller_dealer_id == e.target.value
    )[0];
    getfileterSellerList(selectedSellerDetails);
    dispatch(DealerAction.searchrequest(selectedSellerDetails));
    setFalgFilter(true);
  };

  const getDealername = (data) => {
    let request = {
      seller_id: successData.seller_id,
      seller_token: successData.seller_token,
    };
    API.post("dealerNameDynamic/condition", request)
      .then((response) => {
        if (response.data.success === true) {
          setDealerList(response.data.data);
          setDealerName(response.data.data[0]?.dealer_name);
        } else {
          setErrors(response.data.error.name);
          setErrorFlag(true);
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error);
          setErrorFlag(true);
        }
      });
  };

  const deletedDropdown = (data) => {
    setLoading(true);
    ls.set("carStatus", data)
    let request = {
      seller_dealer_id: dealerData === "" || dealerData === "undefined" || dealerData === null ? successData.seller_dealer_id : dealerData.seller_dealer_id,
      seller_id: successData.seller_id,
      status: data,
      seller_token: successData.seller_token,
    };

    API.post("carStatusDropdown/condition", request)
      .then((res) => {
        if (res.data.success === true) {
          setCarDetail(res.data.data);
          setLoading(false);
        } else {
          setErrors(res.data.error);
          setErrorFlag(true);
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error);
          setErrorFlag(true);
        }
      });
  };


  useEffect(() => {
    getDealername();
    deletedDropdown(Status === undefined || Status === "undefined" || Status === "" ? "inactive" : Status === "Deleted" ? "deleted" : Status);
  }, []);

  useEffect(() => {
    if (dealerData !== null) {
      getfileterSellerList(dealerData);
    }
  }, [dealerData]);

  const searchCarDetail = (data, flag) => {
    // setVinError("");
    // if (VINNumber.length > 0 && VINNumber.length < 6) {
    //   setVinError("VIN number must have last 6 digit");
    //   return;
    // } else if (VINNumber.length > 6) {
    //   setVinError("VIN number accept only last 6 digit");
    //   return;
    // }
setLoading(true);
    let request = {
      seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,
      make: make,
      model: model,
      year: year,
      vin_no: VINNumber,
      status: value == "Inactive" ? "inactive" : value,
      seller_id: successData.seller_id,
      seller_token: successData.seller_token,
    };

    API.post("inActiveCarsSearch/condition", request)
      .then((res) => {
        if (res.data.success === true) {
          setCarDetail(res.data.data);
          setLoading(false);
        } else {
          setErrors(res.data.error);
          setErrorFlag(true);
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error);
          setErrorFlag(true);
          setLoading(false);
        }
      });
  };

  const getfileterSellerList = (data) => {
    setLoading(true);
    let request = {
      seller_dealer_id: data.seller_dealer_id,
      seller_id: successData.seller_id,
      seller_token: successData.seller_token,
      status: value == "Inactive" ? "inactive" : value,
    };
    API.post("inActiveCarsFilter/condition", request)
      .then((response) => {
        if (response.data.success === true) {
          setCarDetail(response.data.data);
          setLoading(false);
        } else {
          setErrors(response.data.error.name);
          setErrorFlag(true);
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error);
          setErrorFlag(true);
          setLoading(false);
        }
      });
  };

  const redirectpage = (pathid, seller_data, seller_dealer_id) => {
    dispatch(UrCarAction.sellerid(seller_data));
    history.push({
      pathname: "/cardetails/",
      state: { backURL: "/inactivecar", id: pathid, sellerId: seller_dealer_id },
    });
  };

  const rerunCarPage = (pathid, seller_data, seller_dealer_id, value) => {
    console.log("check tghe re run value", value);
    dispatch(UrCarAction.sellerid(seller_data));
    history.push({
      pathname: "/reRunEditdetails/",
      state: { backURL: "/inactivecar", id: pathid, sellerId: seller_dealer_id, value: value },
    });
  };

  return (
    <div>
      <main id="search" className="inner-page inActiveCars">
        {errorFlag === true ? <PageNotFound error={errors} /> :
          <div id="recently-cars" className="recently-cars soldCars">
            <div className="container-fluid inner-page-space">



              <div class="common-heading">
                <div className="row">
                  <div className="col-lg-4">
                    <div class="back-btn">
                      <a class="back-btn-primary" onClick={() => history.push("/carlist")}>
                        <i class="bx bx-chevron-left"></i> Back
                      </a>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div class="title">
                      <p class="inner-title">Inactive Cars</p>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div class="title-dropdown">
                      <select
                        id="drop"
                        class="form-control box"
                        onChange={(e) => { deletedDropdown(e.target.value); setValue(e.target.value) }}
                      >
                        <option value="" style={{ "display": "none" }}>{value}</option>
                        <option value="inactive">Inactive</option>
                        <option value="deleted">Deleted</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-lg-4">
                  </div>
                  <div className="col-lg-4">
                  </div>
                  <div className="col-lg-4 mt-2 mb-2">
                    <div class="title-dropdown">
                      <select
                        class="form-control box "
                        id="drop"
                        placeholder=""
                        className={`${dealerData != null ? (dealerData?.color == "pink"
                          ? "tableRowPink  form-control box"
                          : dealerData?.color == "firered"
                            ? "tableRowFireRed  form-control box"
                            : dealerData?.color == "green"
                              ? "tableRowGreenColor form-control box"
                              : dealerData?.color == "darkred"
                                ? "tableRowRed1  form-control box"
                                : " form-control box") :
                          (dealerList[0]?.color == "pink"
                            ? "tableRowPink  form-control box"
                            : dealerList[0]?.color == "firered"
                              ? "tableRowFireRed  form-control box"
                              : dealerList[0]?.color == "green"
                                ? "tableRowGreenColor form-control box"
                                : dealerList[0]?.color == "darkred"
                                  ? "tableRowRed1  form-control box"
                                  : " form-control box")
                          }`}
                        onChange={handleSellerDetailsName}
                      >
                        {dealerData != null ? (
                          <option value={null} style={{ display: "none" }}>
                            {dealerData.dealer_name}({dealerData?.seller_dealer_id})
                          </option>
                        ) : (
                          <option value={null} style={{ display: "none" }}>
                            {dealerList[0]?.dealer_name}({dealerList[0]?.seller_dealer_id})
                          </option>
                        )}
                        {dealerList.length > 0 && (
                          <>
                            {dealerList.map((dealerList, index) => (
                              <option
                                className={dealerList?.color == "pink"
                                  ? "tableRowPink  user_name"
                                  : dealerList?.color == "Silver"
                                    ? "tableRowSilver  user_name"
                                    : dealerList?.color == "Orange"
                                      ? "tableRowOrange  user_name"
                                      : dealerList?.color == "Navy blue"
                                        ? "tableRowNavyBlue  user_name"
                                        : dealerList?.color == "firered"
                                          ? "tableRowFireRed  user_name"
                                          : dealerList?.color == "Purple"
                                            ? "tableRowPurple  user_name"
                                            : dealerList?.color == "Yellow"
                                              ? "tableRowYellow1  user_name"
                                              : dealerList?.color == "green"
                                                ? "tableRowGreenColor user_name"
                                                : dealerList?.color == "blue"
                                                  ? "tableRowBlue  user_name"
                                                  : dealerList?.color == "darkred"
                                                    ? "tableRowRed1  user_name"
                                                    : dealerList?.color == "black"
                                                      ? "tableRowBlack1 user_name"
                                                      : " user_name"} key={dealerList.seller_dealer_id}
                                value={dealerList.seller_dealer_id}
                              >
                                {dealerList.dealer_name}({dealerList?.seller_dealer_id})
                              </option>
                            ))}
                          </>
                        )}
                      </select>
                    </div>
                  </div>
                </div>
              </div>






              <div class="container sellercharges-search">
                <div class="row">
                  <div class="col-lg-3 p-0">
                    <div class="sellercharges-search-field-container">
                      <div class="row">
                        <div class="col-12 border-end">
                          <label for="Year" class="form-label mb-0">
                            Year
                          </label>
                          <input type="text" class="form-control ps-0"
                            id="location"
                            placeholder="Enter Car Year"
                            value={year}
                            onChange={numberPattern} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3 p-0">
                    <div class="sellercharges-search-field-container">
                      <div class="row">
                        <div class="col-12 border-end">
                          <label for="Make" class="form-label mb-0">
                            Make
                          </label>
                          <input type="text" class="form-control ps-0" id="dealername"
                            placeholder="Enter Car Make"
                            onChange={(e) => setMake(e.target.value)} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 p-0">
                    <div class="sellercharges-search-field-container">
                      <div class="row">
                        <div class="col-12 border-end">
                          <label for="Model" class="form-label mb-0">
                            Model
                          </label>
                          <input type="text" class="form-control ps-0" id="dealername"
                            placeholder="Enter Car Model"
                            onChange={(e) => setModel(e.target.value)} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3 p-0">
                    <div class="sellercharges-search-field-container">
                      <div class="row">
                        <div class="col-12 border-end">
                          <label for="Vin" class="form-label mb-0">
                            VIN #
                          </label>
                          <input type="text" class="form-control ps-0"
                            id="date"
                            placeholder="Enter Vin Number"
                            onChange={(e) => setVINNumber(e.target.value)} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-1 p-0">
                    <div class="sellercharges-search-btn">
                      <div class="search-btn">
                        <i class="bx bx-search" onClick={() => searchCarDetail(dealerData)}></i>
                      </div>
                    </div>
                  </div>
                  <div class="errorMsgBox col-lg-12">
                    <p className="form-input-error">{vinError}</p>
                  </div>
                </div>
              </div>
              {loading ? (
                <Loading />
              ) : (
                <>
                  {window.innerWidth >= 992 ? (

                    <div
                      class="row aos-init aos-animate"
                      data-aos="zoom-in"
                      data-aos-delay="100"
                    >
                      {carDetail?.length > 0 ? (
                        carDetail.map((item) => (
                          <div
                            class="col-lg-4"
                            onClick={() => {
                              item.isActive === "1"
                                ? redirectpage(item.carid, item, item.seller_dealer_id, value)
                                : !(sellerStandingStatus === 5 || sellerStandingStatus === 6 || sellerStandingStatus === 7) && rerunCarPage(item.carid, item, item.seller_dealer_id, value);
                            }}
                          >
                            {item.isActive === "1" ? (
                              <div class="car-item ">
                                <div class="soldRibbon">
                                  <h4 class="ribbon">Sold Car</h4>
                                </div>

                                <img src={item.image} class="carImg" alt="..." />
                                <div class="cars-content">
                                  <h3>
                                    <a href="#">
                                      {item.year} {item.make} {item.model}
                                    </a>
                                  </h3>
                                  <div class="km-petrol">
                                    <p class="details">
                                      <img src={speedometer} alt="" />
                                      <span>{item.mileage} {item.mileage_type}</span>
                                    </p>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    {item.fuel_type == "null" ||
                                      item.fuel_type == null ||
                                      item.fuel_type == "" ||
                                      item.fuel_type == "undefined" ||
                                      item.fuel_type == undefined
                                      ? ""
                                      :
                                      <p class="details">
                                        <img src={gasolinePump} alt="" />
                                        <span>
                                          {item.fuel_type}
                                        </span>
                                      </p>}
                                  </div>
                                  <div class="odometer">
                                    <p class="details"><img src={odometer} alt="" /><span>Odometer</span>:&nbsp;{item.odometer == "null" || item.odometer == null || item.odometer == "undefined" || item.odometer == undefined ? "" : item.odometer}</p>
                                  </div>
                                  <div class="cars-prices">
                                    {item.max_price == "" ||
                                      item.max_price == undefined ||
                                      item.max_price == null ? (
                                      ""
                                    ) : (
                                      <div class="prices">
                                        <a class="cta-btns SellPrice">
                                          Sell it now -{" "}
                                          <span>${item.max_price} </span>
                                        </a>
                                      </div>
                                    )}
                                    {item.high_bid == "" ||
                                      item.high_bid == undefined ||
                                      item.high_bid == null ? (
                                      ""
                                    ) : (
                                      <div class="prices">
                                        <a class="cta-btns highBid">
                                          High Bid : <span> ${item.high_bid}</span>
                                        </a>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div class="car-item runout">
                                <div class="runoutOverlay"></div>
                                <img src={item.image} class="carImg" alt="..." />
                                <div class="runoutContent">
                                  <p>Its not running now</p>
                                  <div class="text-center">
                                    {item.isActive == "4" ? (
                                      <a
                                        class={sellerStandingStatus === 5 || sellerStandingStatus === 6 || sellerStandingStatus === 7 ? "redBtn carHistory statuscolor" : "redBtn carHistory"} /* class="cta-btns runit" href="" */
                                      >
                                        {" "}
                                        Deleted{" "}
                                      </a>
                                    ) : (
                                      <a
                                        class={sellerStandingStatus === 5 || sellerStandingStatus === 6 || sellerStandingStatus === 7 ? "redBtn carHistory statuscolor" : "redBtn carHistory"} /*  class="cta-btns runit" href="" */
                                      >
                                        Run it
                                      </a>
                                    )}
                                  </div>
                                </div>

                                <div class="cars-content">
                                  <h3>
                                    <a>
                                      {item.year} {item.make} {item.model}
                                    </a>
                                  </h3>
                                  <div class="d-flex align-items-center mb-3">
                                    <p class="details">
                                      <img src={speedometer} alt="" />
                                      <span>{item.mileage} {item.mileage_type}</span>
                                    </p>
                                    {item.fuel_type == "null" ||
                                      item.fuel_type == null ||
                                      item.fuel_type == "" ||
                                      item.fuel_type == "undefined" ||
                                      item.fuel_type == undefined
                                      ? ""
                                      :
                                      <p class="details">
                                        <img src={gasolinePump} alt="" />
                                        <span>
                                          {item.fuel_type}
                                        </span>
                                      </p>}
                                  </div>
                                  <div class="d-flex align-items-center mb-3">
                                    <p class="details"><img src={odometer} alt="" /><span>Odometer</span>:&nbsp;{item.odometer == "null" || item.odometer == null || item.odometer == "undefined" || item.odometer == undefined ? "" : item.odometer}</p>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        ))
                      ) : (
                        <div class="col-lg-12 nodata">
                          <p>No Data Found</p>{" "}
                        </div>
                      )}
                    </div>)
                    : (
                      <div
                        class="row"

                      >
                        {carDetail?.length > 0 ? (

                          <Slider
                            dots={false}
                            infinite={false}
                            speed={500}
                            responsive={responsiveSettings}
                            centerMode={false}
                          >
                            {carDetail.map((item) => (
                              <div
                                class=""
                                onClick={() => {
                                  item.isActive === "1"
                                    ? redirectpage(item.carid, item, item.seller_dealer_id, value)
                                    : !(sellerStandingStatus === 5 || sellerStandingStatus === 6 || sellerStandingStatus === 7) && rerunCarPage(item.carid, item, item.seller_dealer_id, value);
                                }}
                              >
                                {item.isActive === "1" ? (
                                  <div class="car-item ">
                                    <div class="soldRibbon">
                                      <h4 class="ribbon">Sold Car</h4>
                                    </div>

                                    <img src={item.image} class="carImg" alt="..." />
                                    <div class="cars-content">
                                      <h3>
                                        <a href="#">
                                          {item.year} {item.make} {item.model}
                                        </a>
                                      </h3>
                                      <div class="d-flex align-items-center mb-3">
                                        <p class="details">
                                          <img src={speedometer} alt="" />
                                          <span>{item.mileage} {item.mileage_type}</span>
                                        </p>
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                        {item.fuel_type == "null" ||
                                          item.fuel_type == null ||
                                          item.fuel_type == "" ||
                                          item.fuel_type == "undefined" ||
                                          item.fuel_type == undefined
                                          ? ""
                                          :
                                          <p class="details">
                                            <img src={gasolinePump} alt="" />
                                            <span>
                                              {item.fuel_type}
                                            </span>
                                          </p>}
                                      </div>
                                      <div class="d-flex align-items-center mb-3">
                                        <p class="details"><img src={odometer} alt="" /><span>Odometer</span>:&nbsp;{item.odometer == "null" || item.odometer == null || item.odometer == "undefined" || item.odometer == undefined ? "" : item.odometer}</p>
                                      </div>
                                      <div class="cars-prices">
                                        {item.max_price == "" ||
                                          item.max_price == undefined ||
                                          item.max_price == null ? (
                                          ""
                                        ) : (
                                          <div class="prices">
                                            <a class="cta-btns SellPrice">
                                              Sell it now -{" "}
                                              <span>${item.max_price} </span>
                                            </a>
                                          </div>
                                        )}
                                        {item.high_bid == "" ||
                                          item.high_bid == undefined ||
                                          item.high_bid == null ? (
                                          ""
                                        ) : (
                                          <div class="prices">
                                            <a class="cta-btns highBid">
                                              High Bid : <span> ${item.high_bid}</span>
                                            </a>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div class="car-item runout">
                                    <div class="runoutOverlay"></div>
                                    <img src={item.image} class="carImg" alt="..." />
                                    <div class="runoutContent">
                                      <p>Its not running now</p>
                                      <div class="text-center">
                                        {item.isActive == "4" ? (
                                          <a
                                            class={sellerStandingStatus === 5 || sellerStandingStatus === 6 || sellerStandingStatus === 7 ? "redBtn carHistory statuscolor" : "redBtn carHistory"} /* class="cta-btns runit" href="" */
                                          >
                                            {" "}
                                            Deleted{" "}
                                          </a>
                                        ) : (
                                          <a
                                            class={sellerStandingStatus === 5 || sellerStandingStatus === 6 || sellerStandingStatus === 7 ? "redBtn carHistory statuscolor" : "redBtn carHistory"} /*  class="cta-btns runit" href="" */
                                          >
                                            Run it
                                          </a>
                                        )}
                                      </div>
                                    </div>

                                    <div class="cars-content">
                                      <h3>
                                        <a>
                                          {item.year} {item.make} {item.model}
                                        </a>
                                      </h3>
                                      <div class="d-flex align-items-center mb-3">
                                        <p class="details">
                                          <img src={speedometer} alt="" />
                                          <span>{item.mileage} {item.mileage_type}</span>
                                        </p>
                                        {item.fuel_type == "null" ||
                                          item.fuel_type == null ||
                                          item.fuel_type == "" ||
                                          item.fuel_type == "undefined" ||
                                          item.fuel_type == undefined
                                          ? ""
                                          :
                                          <p class="details">
                                            <img src={gasolinePump} alt="" />
                                            <span>
                                              {item.fuel_type}
                                            </span>
                                          </p>}
                                      </div>
                                      <div class="d-flex align-items-center mb-3">
                                        <p class="details"><img src={odometer} alt="" /><span>Odometer</span>:&nbsp;{item.odometer == "null" || item.odometer == null || item.odometer == "undefined" || item.odometer == undefined ? "" : item.odometer}</p>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            ))}
                          </Slider>
                        ) : (
                          <div class="col-lg-12 nodata">
                            <p>No Data Found</p>{" "}
                          </div>
                        )}
                      </div>
                    )
                  }
                </>
              )}
            </div>

          </div>
        }



      </main>
      <section id="playstoreBlock" class="playstoreBlock">
        <div class="container">
          <div class="row content">
            <div class="col-lg-12">
              <img src={appstore} />
              <img src={googleplay} />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default InActiveCars;
